export default "__VITE_ASSET__3583bb18__"